import React from 'react'
import { CardHeader, Typography, Box, useTheme, styled } from '@mui/material'
import HeaderBgImage from '../header-bg.png'
import { isNilOrEmpty } from 'packages/core'
import { Tooltip } from 'packages/eid-ui'
import config from 'config'

const MyCardHeader = styled(CardHeader)(({ theme }) => ({
    padding: 0,
    width: '100%',
    overflow: 'hidden',
    '& .MuiCardHeader-content': {
        width: '100%',
    },
    '& .MuiCardHeader-title': {
        fontSize: '24px',
        fontWeight: '600',
    },
}))
const maxCharacters = 80

const tooltipStyles = {
    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
    padding: '8px',
    maxWidth: '500px',
}

const ItemHeader = ({ title }) => {
    const theme = useTheme()

    let titleText = isNilOrEmpty(title) ? '' : title
    titleText =
        titleText.length > maxCharacters
            ? `${titleText.substring(0, maxCharacters)}...`
            : titleText

    const titleJsx = (
        <Typography
            sx={{
                width: '100%',
                height: '100%',
                zIndex: 1,
                overflow: 'hidden',
                maxWidth: '690px',
                fontWeight: 'bold',
                fontSize: '28px',
                lineHeight: '38px',
                color: theme?.palette?.common?.white,
                display: 'block',
                wordBreak: 'break-word',
                wordWrap: 'break-word',
            }}
        >
            {titleText}
        </Typography>
    )

    let wrappedTitle

    if (titleText.length > maxCharacters) {
        wrappedTitle = (
            <Tooltip
                title={title}
                color="#5D6870"
                fontColor={theme?.palette?.common?.white}
                enterDelay={500}
                enterNextDelay={500}
                disableInteractive={false}
                tooltipStyles={tooltipStyles}
            >
                {titleJsx}
            </Tooltip>
        )
    } else {
        wrappedTitle = titleJsx
    }

    return (
        <MyCardHeader
            title={
                <Box
                    sx={{
                        padding: '20px',
                        paddingLeft: '32px',
                        position: 'relative',
                        minHeight: '78px',
                        width: '100%',
                        backgroundColor: theme?.palette?.primary?.main,
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                    }}
                >
                    {wrappedTitle}
                    <img
                        style={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            zIndex: 0,
                            right: 0,
                            top: 0,
                        }}
                        src={`${config.APP_SUBPATH}${HeaderBgImage}`}
                        alt="background"
                    />
                </Box>
            }
        />
    )
}

export default ItemHeader
